import { render } from "./A1Data.vue?vue&type=template&id=3a9469f3&scoped=true"
import script from "./A1Data.vue?vue&type=script&lang=js"
export * from "./A1Data.vue?vue&type=script&lang=js"

import "./A1Data.vue?vue&type=style&index=0&id=3a9469f3&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9469f3"]])

export default __exports__